<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 7/27/20
-->

<template>
	<div class="fill-height-root">
		<TabbedLayout
			v-bind="$attrs"
			routeName="BillingMain"
			:tabs="tabs"
		/>

	</div>
</template>

<script>
	import TabbedLayout from "@/core/components/Tabs/TabbedLayout.vue";
	import TabItem from "@/core/components/Tabs/TabItem";
	import InvoiceListPage from "@/core/modules/coach/Billing/view/InvoiceListPage.vue";
	import PaymentMethodsView from "@/core/modules/coach/Billing/view/PaymentIntegrations/PaymentMethodsView.vue";
	export default {
		name: "BillingMain",
		components: {TabbedLayout},

		data() {
			return {
				tabs: [
					new TabItem("Invoices", "invoices", {component: InvoiceListPage}),
					new TabItem("Billing options", "methods", {component: PaymentMethodsView}),
				]
			}
		},
	}
</script>

<style>

</style>

